"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBuff = void 0;
const __1 = require("../..");
const Effects_1 = require("../../metadata/Effects");
const enums_1 = require("../enums");
const DefaultArgs = {
    supernatural: false,
    onApplied: () => { },
};
function applyBuff(args) {
    args = {
        ...DefaultArgs,
        ...args
    };
    const { creatorId, targetId, effect, duration, supernatural, onApplied, hidden } = args;
    let { sequence } = args;
    const buffId = this.applyEffect(sequence, creatorId, targetId, effect, duration, supernatural);
    // linked effects are always hidden
    if (!hidden && effect.__typeName !== "LinkedEffects") {
        const [text, color] = (0, Effects_1.printEffect)("apply", effect, targetId, this);
        if (text) {
            duration.type !== enums_1.DurationType.Instant && sequence.push(new __1.BattleLogEntryVfxStepArgs([
                __1.BattleLogEntrySegment.actorName(this, targetId),
                new __1.BattleLogEntrySegment(text, color),
            ]));
            sequence.push(new __1.FloatingTextVfxStepArgs(text, new __1.ActorVfxLocationSelector(targetId, "random"), color, "small"));
            sequence.push(new __1.EffectApplyVfxStepArgs(buffId, new __1.ActorVfxLocationSelector(targetId), text, color));
        }
    }
    onApplied(sequence, args);
    return buffId;
}
exports.applyBuff = applyBuff;
